import React, {ReactElement} from "react";
import {BreadcrumbsProps} from "peggirkit/dist/components/Breadcrumbs";
import {Breadcrumbs, BreadcrumbsPage} from "peggirkit";
import {Route} from "@/routing/Router";
import {IntlShape} from "react-intl";

export const generateBreadcrumbs = (currentPage: Route, intl: IntlShape): ReactElement<BreadcrumbsProps> => {
    let pages: BreadcrumbsPage[] = [];
    let current: Route | undefined = currentPage;

    while (current != undefined) {
        pages.push({
            name: current.name(intl),
            to: current.absolutePath(),
        });
        current = current.precededBy
    }

    pages = pages.reverse();

    return (
        <Breadcrumbs
            pages={pages}
            usePrevPageLink={true}
            breakpoints={{
                md: {
                    usePrevPageLink: false
                }
            }}
        />
    );
};